import { CompassCardUI } from '@scale/compass-ui/types';
import {
  TaskActionsCardShared,
  type TaskActionsSchemaType,
  type TaskActionsContext,
  TASK_ACTIONS,
} from '@scale/genai-compass-shared/cards/task_actions';
import { faGears } from '@fortawesome/pro-solid-svg-icons';
import TaskActionsCardComponent from 'react-scale/corp/views/DataCompassCardsV2/action/TaskActions/TaskActionsCardComponent';

const defaultContext: TaskActionsContext = {
  cardType: TASK_ACTIONS,
  traitName: '',
  traitParams: {},
};

export const TaskActionsCardInfo: CompassCardUI<TaskActionsSchemaType> = {
  ...TaskActionsCardShared,
  title: 'Task Actions',
  icon: 'wand-magic-sparkles',
  toolTip: 'Perform actions on tasks.',
  defaultContext,
  button: {
    icon: faGears,
  },
  legacyComponent: TaskActionsCardComponent,
};
